import { SideRenderer } from 'components/Table/renderers/SideRenderer';
import {
  Alignment,
  Column,
  ColumnDefinition,
  ColumnType,
  createFromDefinition,
} from 'components/Table/types/column';
import fixFieldEntries from 'data/fix';
import dictionary from 'data/fixDictionary';
import { ExecutionRowTool } from 'routes/Executions/ExecutionRowTool';
import { Execution, fixMap, fixTagToExecutionKey } from 'types/summaryReport';

export const columnDefinitions: ReadonlyArray<ColumnDefinition<Execution>> = [
  {
    columnType: ColumnType.custom,
    header: '',
    key: 'id',
    component: ExecutionRowTool,
    minWidth: 40,
    weight: 0.25,
    filterable: false,
  },
  {
    columnType: ColumnType.dateTime,
    header: 'Transaction Time',
    key: 'transactionTime',
    weight: 2,
    filterable: true,
    sortable: true,
  },
  {
    columnType: ColumnType.text,
    header: 'Client Order ID',
    key: 'clientOrderId',
    alignment: Alignment.center,
    weight: 2,
    filterable: true,
    sortable: true,
  },
  {
    columnType: ColumnType.text,
    header: 'Symbol',
    key: 'symbol',
    alignment: Alignment.center,
    weight: 1,
    filterable: true,
    sortable: true,
  },
  {
    columnType: ColumnType.custom,
    header: 'Side',
    key: 'side',
    alignment: Alignment.center,
    weight: 1,
    component: SideRenderer,
    filterable: true,
    sortable: true,
  },
  {
    columnType: ColumnType.text,
    header: 'CumQty',
    key: 'cumQty',
    alignment: Alignment.center,
    weight: 1,
    filterable: true,
    sortable: true,
  },
  {
    columnType: ColumnType.text,
    header: 'AvgPx',
    key: 'avgPx',
    alignment: Alignment.center,
    weight: 1,
    filterable: true,
    sortable: true,
  },
  {
    columnType: ColumnType.text,
    header: 'Ord Status',
    key: 'ordStatus',
    alignment: Alignment.center,
    weight: 1,
    filterable: true,
    sortable: true,
  },
  {
    columnType: ColumnType.text,
    header: 'Exec Type',
    key: 'execType',
    alignment: Alignment.center,
    weight: 1,
    filterable: true,
    sortable: true,
  },
];

export const columns = columnDefinitions.map(createFromDefinition);

export const createExecutionColumnFromFixTag = (tag: string): Column<Execution> | undefined => {
  const baseColumn = columns.find(
    (column: Column<Execution>): boolean => fixMap[column.key as keyof Execution] === tag
  );

  if (baseColumn !== undefined) {
    return baseColumn;
  }

  const field =
    dictionary[tag] ??
    (fixFieldEntries[tag] as { readonly name: string; readonly type: string } | undefined);

  if (!field) {
    return undefined;
  }

  const executionKey = fixTagToExecutionKey(tag) ?? tag;

  return createFromDefinition<Execution>({
    key: executionKey as keyof Execution,
    header: field.name,
    columnType: ColumnType.text,
    weight: 1,
  } as ColumnDefinition<Execution>);
};

export default columnDefinitions;
